export default {
  methods: {
    translateFarmersCopy(str) {
      return str
        .replace(/Farmers Fee/i, 'Processing Fee')
        .replace(/FARMERS_FEE/i, 'ADMIN_FEE')
    },
  },
}
